import { UserType } from '@llx/common';

import { MeetingFieldsFragment } from '@/@generated/codegen/API';

export default function shouldActivateUserListFeature(
  meeting: MeetingFieldsFragment,
  userType: UserType
) {
  if (!meeting?.streamUrl) return false;
  return userType === UserType.ADMIN;
}
